import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import type { WithdrawalsFiltersType } from "../types/payouts.type";
import { mapWithdrawalStatus } from "../mappers/payouts.mapper";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

export function useFetchWithdrawals(
  filters: WithdrawalsFiltersType = {},
  cursor?: string
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      cursor,
      createdAtRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      statuses:
        filters.status &&
        mapWithdrawalStatus[filters.status as keyof typeof mapWithdrawalStatus]
          ? [
              mapWithdrawalStatus[
                filters.status as keyof typeof mapWithdrawalStatus
              ],
            ]
          : undefined,
    }),
    [merchant?.id, cursor, filters]
  );

  const { data, isLoading, refetch } = useQuery(
    trpc.withdrawals.list.queryOptions(queryInput, { enabled: !!merchant?.id })
  );

  const withdrawals = data?.data || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = data?.length || 0;

  return {
    withdrawals,
    nextCursor,
    totalItems,
    isLoading,
    refetch,
  };
}
